const Modal = ({
    title,
    message,
    action,
    actionMessage,
    actionSecond,
    actionSecondMessage,
}: {
    title: string;
    message: string;
    action: () => void;
    actionMessage: string;
    actionSecond?: () => void;
    actionSecondMessage?: string;
}) => {
    return (
        <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
          <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
            <div className="relative bg-white rounded-2xl shadow p-5">
             <div className="w-full flex flex-col items-center pb-3">
                <p className="self-center text-lg mt-3 font-bold mb-3">{title}</p>
                <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                <p className="text-sm mt-2 text-center">{message}</p>
                <button type="button" onClick={action} className="mt-3 mb-3 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">{actionMessage}</button>
                {actionSecondMessage && <button type="button" onClick={actionSecond} className="mt-1 mb-3 text-black underline">{actionSecondMessage}</button>}
              </div>
            </div>
          </div>
        </div>
    );
}

export default Modal;